<template>
  <div>
    <headerNav title="云微商返利" />
    <div class="hy" v-if="userInfo">
      <div class="hy-f">
        <div class="hy-f-tit">可用金额(元)</div>
        <div class="hy-f-price">
          <span>{{ userInfo.cloudMoney }}</span>
          <div class="hy-f-price-fr" @click="goto('/cloudwithdraw')">
            明细
            <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
          </div>
        </div>
        <div class="hy-f-btns">
          <van-button class="hy-f-btn" @click="tx" color="#ff9970" round>提现</van-button>
          <van-button class="hy-f-btn" @click="toLoans" color="#ff9970" round>转余额</van-button>
        </div>
      </div>
      <div class="hy-f">
        <div class="hy-f-list">
          <div class="hy-f-info" @click="goto('/cloudwithdraw', 3)">
            <div>冻结金额(元)</div>
            <div class="hy-f-info-fr">
              <span>{{ userInfo.cloudFrozenMoney }}</span>
              <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
            </div>
          </div>
          <!-- 没有字段没有实现!-->
          <div class="hy-f-info" @click="goto('/cloudwithdraw', 2)">
            <span>已提现(元)</span>
            <div class="hy-f-info-fr">
              <span>{{ userInfo.cloudWithdrawMoney }}</span>
              <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="hy-f" @click="gobank">
        <div class="hy-f-list">
          <div class="hy-f-info">
            <span>默认银行卡</span>
            <div class="hy-f-info-fr">
              <span>{{ bank ? "已绑定" : "未绑定" }}</span>
              <van-icon class="main-list-icon-left" :size="14" :color="$abctheme.basecolor" class-prefix="abc-icon" name="you" />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <van-dialog v-model="show" @confirm="ontx" title="提现" :before-close="bclose" close-on-popstate show-cancel-button>
      <van-cell-group>
        <van-field v-model="txinfo.money" type="number" label="金额" placeholder="请输入提现金额" />
      </van-cell-group>
    </van-dialog>

    <van-dialog v-model="showtoLoans" title="转货款" show-cancel-button @confirm="confirmtoLoans">
      <van-field v-model="toLoansModel.money" label="金额" input-align="right" />
      <van-radio-group v-model="toLoansModel.method">
        <van-cell-group>
          <van-cell title="转大货货款" clickable @click="toLoansModel.method = '0'">
            <template #right-icon>
              <van-radio name="0" />
            </template>
          </van-cell>
          <van-cell title="转物料货款" clickable @click="toLoansModel.method = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: undefined,
      show: false,
      number: undefined,
      bank: undefined,

      txinfo: {
        brankId: undefined,
        money: undefined,
      },
      toLoansModel: {
        method: "0",
        money: "",
      },
      showtoLoans: false,
    };
  },
  created() {
    this.init();
    this.abp.event.on("app.CloundWithDrawApply", (x) => {
      this.isload = false;
      this.$toast.clear();
      if (x.status != 0) {
        this.$toast(x.errMsg);
      } else {
        this.show = false;
        this.$toast("提现成功");
        this.queryuserinfo();
      }
    });
  },
  methods: {
    bclose(action, done) {
      if (action === "confirm") {
        console.log(1234);
        done(false);
      } else {
        done();
      }
    },
    init() {
      //获取当前默认银行卡
      this.ajax.post("/api/services/app/PhoneUser/QueryDefaultBank").then((x) => {
        this.bank = x.result;
      });
      this.queryuserinfo();
    },
    queryuserinfo() {
      this.ajax.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
        this.userInfo = x.result;
        this.abp.userInfo = x.result;
      });
    },
    //立即提现
    ontx() {
      if (!this.bank) {
        this.$toast("请先设置默认银行卡");
        return;
      }
      if (!this.txinfo.money) {
        this.$toast("请先输入金额");
        return;
      }
      this.txinfo.brankId = this.bank.id;
      //创建提现
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提现中",
      });
      this.ajax
        .post("/api/services/app/PhoneClound/CreateCloundWithdraw", this.txinfo)
        .then((x) => {
          //等待队列
        })
        .catch((x) => {
          this.$toast.clear();
          this.queryuserinfo();
        });
    },
    tx() {
      if (!this.bank) {
        this.$dialog.confirm({
          title:'未设置默认银行卡,无法提现',
          message:'点击确定前往银行卡绑定'
        })
        .then(()=>{
          this.$router.push({
            name:'brank'
          })
        })
        return;
      }
      if (!this.abp.userInfo.wxPramOpenId) {
          this.$dialog.confirm({
            title:'未绑定微信,无法申请提现',
            message:'点击确定前往微信绑定!'
          })
          .then(()=>{
            this.$router.push({
              name:'set'
            })
          })
          return;
        }

      this.txinfo.money = undefined;
      this.show = true;
    },
    goto(url, state) {
      if (state) {
        this.$router.push({
          path: url,
          query: {
            state: state,
          },
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    gobank() {
      this.$router.push({
        path: "/brank",
      });
    },
    toLoans() {
      this.showtoLoans = true;
    },
    confirmtoLoans() {
      if (!this.toLoansModel.money) {
        this.$dialog.alert({message:"请输入正确的金额"});
        return;
      }
      this.ajax.post("/api/services/app/PhoneClound/CloundToLoans?method=" + this.toLoansModel.method + "&money=" + this.toLoansModel.money).then((x) => {
        this.queryuserinfo();
        this.$toast.success("转货款成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hy {
  margin: 10px;
  font-size: 12px;
}
.hy-f {
  padding: 14px;
  background-color: #fff;
  border-radius: 16px;
  margin-bottom: 10px;
}
.hy-f-tit {
  font-size: 18px;
  margin-bottom: 20px;
}
.hy-f-price {
  font-size: 16px;
  margin-bottom: 20px;
  position: relative;
}
.hy-f-price-fr {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.hy-f-btns {
  text-align: center;
}
.hy-f-btn {
  padding: 5px 50px;
  background-color: red;
}
.hy-f-info {
  position: relative;
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 14px;
}
.hy-f-info:first-child {
  margin-top: 0;
}

.hy-f-info:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.hy-f-info-fr {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
